import { dayJs } from '@/utils/day-js';

export const getRelativeTime = (raw: string) => dayJs(raw).fromNow();
